import placeOrderIcon from '../../assets/images/icons/mobiles/tab_icon_trade_default@2x.png';
import marketIcon from '../../assets/images/icons/mobiles/tab_icon_market_default@2x.png';
import tradeIcon from '../../assets/images/icons/mobiles/tab_icon_order_default@2x.png';
import accountIcon from '../../assets/images/icons/mobiles/tab_icon_myacc_default@2x.png';
import placeOrderActiveIcon from '../../assets/images/icons/mobiles/tab_icon_trade_hit@2x.png';
import marketActiveIcon from '../../assets/images/icons/mobiles/tab_icon_market_hit@2x.png';
import tradeActiveIcon from '../../assets/images/icons/mobiles/tab_icon_order_hit@2x.png';
import accountActiveIcon from '../../assets/images/icons/mobiles/tab_icon_myacc_hit@2x.png';
import { PERMISSION } from '../../constants/permission';
import { PATH } from '@/constants/paths';

export const navigateMobileConfig = {
  EIFMobileNavigate:[
    {
      id: 'trade',
      key: 0,
      label: 'menu_trade',
      icon: tradeIcon,
      navLink: PATH.TRADE,
      type: 'item',
      permissions: PERMISSION.TRADING,
      enabled: true,
      isAuthenticated: true,
      isMobileNavDisplay: true,
      isActive:tradeActiveIcon
    },
    {
      id: 'market',
      key: 1,
      label: 'menu_market',
      icon: marketIcon,
      navLink: PATH.MARKET_DATA,
      type: 'item',
      permissions: [],
      enabled: true,
      isAuthenticated: false,
      isMobileNavDisplay: true,
      isActive:marketActiveIcon
    },
    {
      id: 'place_order',
      key: 2,
      label: 'menu_place_order',
      icon: placeOrderIcon,
      navLink: PATH.PLACE_ORDER,
      type: 'item',
      permissions: PERMISSION.TRADING,
      enabled: true,
      isAuthenticated: true,
      isMobileNavDisplay: true,
      isActive:placeOrderActiveIcon
    },
    {
      id: 'my_account',
      key: 3,
      label: 'menu_account',
      icon: accountIcon,
      navLink: PATH.ACCOUNT_DATA,
      type: 'item',
      permissions: PERMISSION.TRADING,
      enabled: true,
      isAuthenticated: true,
      isMobileNavDisplay: true,
      isActive:accountActiveIcon
    }
  ],
  TTLMobileNavigate:[
    {
      id: 'trade',
      key: 0,
      label: 'menu_trade',
      icon: tradeIcon,
      navLink: PATH.TRADE,
      type: 'item',
      permissions: PERMISSION.TRADING,
      enabled: true,
      isAuthenticated: true,
      isMobileNavDisplay: true,
      isActive:tradeActiveIcon
    },
    {
      id: 'market',
      key: 1,
      label: 'menu_market',
      icon: marketIcon,
      navLink: PATH.MARKET_DATA,
      type: 'item',
      permissions: [],
      enabled: true,
      isAuthenticated: false,
      isMobileNavDisplay: true,
      isActive:marketActiveIcon
    },
    {
      id: 'my_account',
      key: 2,
      label: 'menu_account',
      icon: accountIcon,
      navLink: PATH.ACCOUNT_DATA,
      type: 'item',
      permissions: PERMISSION.TRADING,
      enabled: true,
      isAuthenticated: true,
      isMobileNavDisplay: true,
      isActive:accountActiveIcon
    }
  ],
}
